import { Component, Input } from '@angular/core';
import { RequirementField } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'ba-boolean',
    templateUrl: 'boolean-attribute.component.html'
})

export class BooleanAttributeComponent {

    @Input() field: RequirementField;
    @Input() form: UntypedFormGroup;
    @Input() disabled: boolean;

    options = [
        { value: null, label: 'Not specified' },
        { value: '1', label: 'Yes' },
        { value: '0', label: 'No' }
    ];

    get fieldValue() {
        const valueOption = this.options.find((option) => option.value === this.field.value);
        if (valueOption) {
            return valueOption.label;
        }
        return '';
    }
}
